import React from 'react';

const IconEyeHide = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M15.6565 7.5C17.1043 8.75 18 10 18 10C18 10 14.4174 15 10 15C9.42492 15 8.86398 14.9153 8.32326 14.7678M6.25094 13.8778C3.72228 12.4037 2 10 2 10C2 10 5.58261 5 10 5C11.457 5 12.8232 5.54396 14 6.27305"
        stroke="#111111"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.23224 8.23223C7.25593 9.20854 7.25593 10.7915 8.23224 11.7678L11.7678 8.23223C10.7915 7.25592 9.20856 7.25592 8.23224 8.23223Z"
        fill="#111111"
      />
      <path d="M17 2.99991L2.99992 17" stroke="#111111" strokeWidth="1.5" />
    </svg>
  );
};

export default IconEyeHide;
